import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EsgCategoriesFilterPipe } from './esg-categories-filter.pipe';
import { EsgTitlePipe } from './esg-title.pipe';
import { SfdrArticlePipe } from './sfdr-article.pipe';
import { SfdrDescriptionPipe } from './sfdr-description.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [EsgTitlePipe, EsgCategoriesFilterPipe, SfdrArticlePipe, SfdrDescriptionPipe],
  exports: [EsgTitlePipe, EsgCategoriesFilterPipe, SfdrArticlePipe, SfdrDescriptionPipe]
})
export class EsgCommonPipeModule {}
